module.exports = __webpack_public_path__ + "static/media/AS.08c44097.svg";